// src/pages/RefundPolicy.js
import React from "react";
import "./PolicyPages.css";

export default function RefundPolicy() {
  return (
    <div className="policy-container">
      <div className="policy-card">
        <h1>Refund &amp; Cancellation Policy</h1>
        <p className="policy-date">Last updated: September 2026</p>

        <section>
          <h2>1. Membership fees</h2>
          <p>
            Membership fees paid to Marakwet Community in Australia Inc. (MCIA)
            are <strong>non-refundable</strong> once payment has been successfully
            processed. This is because membership is a digital service that is
            activated immediately upon successful payment.
          </p>
          <p>
            If you believe a payment was made in error (for example, a duplicate
            charge), please contact us within <strong>7 days</strong> of the
            transaction at{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>{" "}
            and we will review your request.
          </p>
        </section>

        <section>
          <h2>2. Event tickets</h2>
          <p>
            All event ticket purchases are <strong>non-refundable</strong> once
            payment has been successfully processed. Please ensure you review
            event details carefully before completing your purchase.
          </p>
          <p>
            If MCIA cancels an event, ticket holders will receive a full refund
            to their original payment method via Stripe within 5–10 business days.
            You will be notified by email if an event is cancelled.
          </p>
          <p>
            If you believe a ticket payment was made in error (for example, a
            duplicate charge), please contact us within <strong>7 days</strong>{" "}
            of the transaction at{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>{" "}
            and we will review your request.
          </p>
        </section>

        <section>
          <h2>3. Welfare program payments</h2>
          <p>
            Welfare support program instalment payments (weekly, fortnightly or
            monthly) that have already been processed cannot be reversed. However,
            you may cancel future instalments at any time by contacting us before
            the next scheduled payment date.
          </p>
          <p>
            Any welfare funds already paid remain allocated to your welfare account
            and will be applied when a welfare claim is made, subject to the
            welfare program terms.
          </p>
        </section>

        <section>
          <h2>4. Cancellation of a transaction</h2>
          <p>
            If you wish to cancel a payment that is in progress (not yet settled),
            please contact us immediately at{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>{" "}
            or call +61 411 494 404. Once a payment has been settled by the
            bank, it cannot be reversed through our system and a refund review
            process will apply.
          </p>
        </section>

        <section>
          <h2>5. How to request a refund</h2>
          <p>To request a refund review, please email us with:</p>
          <ul>
            <li>Your full name and email address used to register</li>
            <li>The date and amount of the payment</li>
            <li>The reason for your refund request</li>
          </ul>
          <p>
            Email:{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>
            <br />
            We aim to respond within 5 business days.
          </p>
        </section>

        <section>
          <h2>7. Delivery of services</h2>
          <p>
            MCIA provides digital membership and event ticketing services only —
            there are no physical goods involved. Membership access is granted{" "}
            <strong>immediately upon successful payment</strong>. You will receive
            a confirmation email with a link to set your password and access your
            member account.
          </p>
          <p>
            Event tickets are delivered digitally via email upon successful payment.
            If you do not receive your confirmation email within 15 minutes, please
            check your spam folder or contact us at{" "}
            <a href="mailto:info@marakwetcommunityinaustralia.org">
              info@marakwetcommunityinaustralia.org
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
}